<template>
  <div>
    <UnsubmittedPrs/>
  </div>
</template>
  
  <script>
  // @ is an alias to /src
  import UnsubmittedPrs from '@/components/UnsubmittedPrs.vue'
  
  export default {
    name: 'penidng-approval-view',
    components: {
      UnsubmittedPrs
    }
  }
  </script>
  